import React, { Fragment } from 'react';
import intl from 'react-intl-universal';
import { withRouter } from 'react-router-dom';
import IdleTimer from 'react-idle-timer';
import { INIT_COUNT, IDLE_TIMEOUT, LOGOUT_URL } from 'src/constants/constants.js';
import { ConfirmDialog } from 'src/ui/library/Dialog';
import { connect } from 'react-redux';

import { checkStatusPending } from 'src/ui/features/Messaging/state/messagingActions';

class LayoutContainer extends React.Component {
  idleTimer = null;
  state = {
    expiryDialog: {
      open: false,
    },
    count: INIT_COUNT,
    timeout: IDLE_TIMEOUT,
  };
  secondsRemaining;
  intervalHandle;
  timeOutHandle;

  tick = () => {
    if (this.state.count <= 0) {
      this.clearIntervalHandle();
    } else {
      this.setState(prevState => ({
        count: --prevState.count,
      }));
    }
  };
  clearIntervalHandle = () => {
    clearInterval(this.intervalHandle);
    clearTimeout(this.timeOutHandle);
    this.props.history.push(LOGOUT_URL);
  };
  _onIdle = e => {
    this.idleTimer.pause();

    this.toggleModal();
    this.startCountdown();
  };
  startCountdown = () => {
    this.intervalHandle = setInterval(this.tick, 1000);
    /* temporary fix to implement logout to resolve setInterval function invalid behaviour */
    this.timeOutHandle = setTimeout(() => {
      if (this.state.count !== 0) {
        this.clearIntervalHandle();
      }
    }, 31000);
  };
  toggleModal = () => {
    /* */
    this.setState({
      expiryDialog: {
        open: !this.state.expiryDialog.open,
      },
    });
  };
  _onCancel = () => {
    /* */
    this.toggleModal();
    clearInterval(this.intervalHandle);
    clearTimeout(this.timeOutHandle);
    this.props.history.push(LOGOUT_URL);
    sessionStorage.setItem('token', null);
    sessionStorage.setItem('userInfo', {});
  };
  _onConfirm = () => {
    /* */
    this.toggleModal();
    clearInterval(this.intervalHandle);
    clearTimeout(this.timeOutHandle);
    this.idleTimer.reset();
    this.setState({
      count: INIT_COUNT,
    });
  };
  render() {
    return (
      <Fragment>
        <IdleTimer
          ref={ref => {
            this.idleTimer = ref;
          }}
          timeout={this.state.timeout}
          onIdle={this._onIdle}>
          {this.props.children}
        </IdleTimer>
        <ConfirmDialog
          open={this.state.expiryDialog.open}
          title={intl.get('global.expiryMessage.title')}
          cancelText={intl.get('global.expiryMessage.cancelText')}
          confirmText={intl.get('global.expiryMessage.confirmText')}
          onCancel={this._onCancel}
          onConfirm={this._onConfirm}>
          <span>{intl.get('global.expiryMessage.text', { val: `${this.state.count}` })}</span>
        </ConfirmDialog>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  userInfo: state.login.userInfo,
});

const mapDispatchToProps = {
  checkStatusPending,
};

const LayoutContainerWithRouter = withRouter(LayoutContainer);

export default connect(mapStateToProps, mapDispatchToProps)(LayoutContainerWithRouter);
